if (!customElements.get('marquee-text')) {
  customElements.define(
    'marquee-text',
    class MarqueeText extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.marquee__track');
        if (!this.track) return;

        this.original = this.track.querySelector('.marquee__group');
        if (!this.original) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktopMq = window.matchMedia('(min-width: 750px)');

        this._onResize = this.debounce(() => this.layout(), 150);
        this._onMedia = () => this.layout();

        window.addEventListener('resize', this._onResize);
        this.desktopMq.addEventListener('change', this._onMedia);
        this.reducedMotion.addEventListener('change', this._onMedia);

        this.layout();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._onResize);
        if (this.desktopMq) this.desktopMq.removeEventListener('change', this._onMedia);
        if (this.reducedMotion) this.reducedMotion.removeEventListener('change', this._onMedia);
      }

      debounce(fn, wait) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), wait);
        };
      }

      layout() {
        // Remove any groups we cloned on a previous pass, keep the original.
        this.track.querySelectorAll('.marquee__group').forEach((group) => {
          if (group !== this.original) group.remove();
        });

        if (this.reducedMotion.matches) {
          this.track.style.removeProperty('--marquee-duration');
          this.track.style.removeProperty('--marquee-distance');
          return;
        }

        // One "period" = the width of a single group (item margins include the
        // trailing gap, so no separate inter-group gap needs adding).
        const distance = this.original.getBoundingClientRect().width;
        if (!distance) return;

        // Clone the group until the track is at least twice the container width
        // so the loop stays full across every viewport. Always keep >= 2 groups.
        const containerWidth = this.getBoundingClientRect().width;
        let safety = 0;
        while (
          (this.track.scrollWidth < containerWidth * 2 ||
            this.track.querySelectorAll('.marquee__group').length < 2) &&
          safety < 40
        ) {
          const clone = this.original.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
          safety += 1;
        }

        const speed = this.desktopMq.matches
          ? parseFloat(this.dataset.speedDesktop)
          : parseFloat(this.dataset.speedMobile);
        const pxPerSecond = speed && speed > 0 ? speed : 60;

        this.track.style.setProperty('--marquee-distance', `${distance}px`);
        this.track.style.setProperty('--marquee-duration', `${distance / pxPerSecond}s`);
      }
    }
  );
}